export const CART_UPDATE = "CART_UPDATE";
export const CART_CLEAR = "CART_CLEAR";


// WEBPACK FOOTER //
// ./src/ducks/cart/constants.js